<template>
  <a class="item-paca ripple" href="#" @click.prevent="$emit('click')">
    <img :src="icono" :class="clase" class="img-bg-paca" />
    <div>
      <div class="titulo-paca">{{ titulo }}</div>
      <div class="subtitulo-paca">{{ subtitulo }}</div>
    </div>
  </a>
</template>

<script>
export default {
  props: {
    icono: {
      type: String,
      required: true
    },
    titulo: {
      type: String,
      required: true
    },
    subtitulo: {
      type: String,
      required: false,
      default: null
    },
    clase: {
      type: String,
      required: false,
      default: "poliza"
    }
  }
};
</script>

<style lang="scss" scoped>
.item-paca {
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  margin-bottom: 0.9rem;
}

.titulo-paca {
  color: lighten($azulOscuroMMT, 10%);
  font-weight: 500;
}

.subtitulo-paca {
  color: lighten($azulOscuroMMT, 40%);
}

.img-bg-paca {
  margin-right: 10px;
  width: 2.5rem;
  background-color: darken($azulClaroMMT, 10%);
  border: 1px solid gray;
  border-radius: 50%;
}

a {
  text-decoration: none;
}
</style>
